import * as Sentry from "@sentry/browser";
Sentry.init({
  dsn: "https://e3d6ea52f2e749619eede109ee201f92@sentry.io/1544021"
});

export default Sentry;



// WEBPACK FOOTER //
// ./src/App/Globals/sentry.js